import React from 'react';
import Layout from 'layout';
import { ExtendGridBox } from 'pages/integrations/analytics';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const Marketers = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Intercom');
  return (
    <Layout
      metaTitle="Marketers | Integrations"
      canonical="/integrations/for-marketers/"
      metaDescription="Connect LiveSession to your favorite marketing tools and learn more about your users. This data will help you optimize your marketing strategy."
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/for-marketers/">
                <strong>Marketers</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="Marketers" />
          <Content activeCategory="Marketers" hideTitle>
            <Banner
              activeCategory="Marketers"
              card={mostPopularCard}
              text="Connect LiveSession to your favorite marketing tools and learn more about your users. This data will help you optimize your marketing strategy."
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default Marketers;
